// extracted by mini-css-extract-plugin
export default {"text":"NoApplicableData_text__4pndF"};